import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyBM4APy7VtZJVdgVjHi2CXourgljNDQqZA",
    authDomain: "discord-clone-cc4bb.firebaseapp.com",
    databaseURL: "https://discord-clone-cc4bb.firebaseio.com",
    projectId: "discord-clone-cc4bb",
    storageBucket: "discord-clone-cc4bb.appspot.com",
    messagingSenderId: "798491467698",
    appId: "1:798491467698:web:a823c2c6df753e69a40eab"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  export {auth, provider};
  export default db;